export const keys = {
    auth: {
        session: () => ['auth', 'session'],
        account: () => ['auth', 'account'],
        passkeys: () => ['auth', 'passkeys']
    },
    pds: {
        list: (ApplicationID) => ['pds', {ApplicationID}],
        detail: (PDSID,ApplicationID) => ['pds','detail', {PDSID, ApplicationID}]
    },
    client: {
        info: (medicaidid) => ['client','info',{medicaidid}]
    },
    clientSearch: {
        results: (params) => ['client-search', { ...params }]
    },
    applications: {
        list: (medicaidid) => ['applications',{medicaidid}],
        demographics: (applicationid) => ['applications','demographics',{applicationid}]
    },
    incidents: {
        list: (medicaidid) => ['incidents',{medicaidid}],
        detail: (id) => ['incident',{id}],
        defintions: () => ['incidents','definitions']
    },
    screening: {
        detail: (ApplicationID) => ['screening',{ApplicationID}]
    },
    applicationHistory: {
        list: (ApplicationID) => ['history',{ApplicationID}]
    },
    applicationStatus: {
        all: () => ['application-status'],
        definitions: () => ['application-status','definitions'],
        list: (ApplicationID,ShowVoids,ShowInformationOnly) => ['application-status','list',{ApplicationID,ShowVoids,ShowInformationOnly}],
        detail: (ApplicationID,StatusID) => ['application-status','detail',{ApplicationID,StatusID}],
        transitionSummary: (ApplicationID) => ['application-status','transition-summary',{ApplicationID}]
    },
    announcements: {
        list: () => ['announcements']
    },
    emailNotifications: {
        list: () => ['email-notifications']
    },
    home: {
        dashboardRoot: () => ['home', 'dashboard'],
        dashboard: (payload) => ['home', 'dashboard', payload]
    },
    reports: {
        catalog: () => ['reports', 'catalog'],
        result: (reportId, params) => ['reports', 'result', { reportId, params: { ...params } }]
    },
    auditLogs: {
        list: (params) => ['audit-logs', { ...params }]
    },
    errorLogs: {
        list: (params) => ['error-logs', { ...params }]
    },
    quickLinks: {
        config: () => ['quick-links', 'config']
    },
    manageGroupApp: {
        definitions: () => ['manage-group-app', 'definitions'],
        role: (RoleID) => ['manage-group-app', 'role', {RoleID}]
    },
    documents: {
        list: (ApplicationID) => ['documents', {ApplicationID}]
    }
}
